package dev.lingvo.site.ds

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.ElementBuilder
import org.jetbrains.compose.web.dom.TagElement
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.HTMLElement

private val KbdElement = ElementBuilder.createBuilder<HTMLElement>("kbd")

val LKbdStyle = CssStyle.base {
    Modifier
        .styleModifier { property("display", "inline-flex") }
        .alignItems(AlignItems.Center)
        .justifyContent(JustifyContent.Center)
        .minWidth(24.px)
        .height(24.px)
        .backgroundColor(colorMode.toSitePalette().surfaceSunken)
        .color(colorMode.toSitePalette().textSecondary)
        .border(1.px, LineStyle.Solid, colorMode.toSitePalette().borderStrong)
        .borderRadius(Radius.Control)
        .padding(leftRight = Space.XS)
        .fontSize(TypeScale.Micro)
        .fontWeight(500)
        .monoFont()
        .whiteSpace(WhiteSpace.NoWrap)
        .styleModifier {
            property("box-shadow", "inset 0 -1px 0 ${colorMode.toSitePalette().borderStrong}")
        }
}

@Composable
fun LKbd(
    text: String,
    modifier: Modifier = Modifier,
) {
    TagElement(
        elementBuilder = KbdElement,
        applyAttrs = LKbdStyle.toModifier().then(modifier).toAttrs(),
        content = { Text(text) },
    )
}
